import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { ProductFormProductPackaging } from "src/pages/Product/ProductForm/ProductForm.types";

type LineContentProps = {
    packaging: ProductFormProductPackaging;
};
export const LineContent = (props: LineContentProps) => {
    const { packaging } = props;
    const { selectedCompany } = useFoodpilotContext();
    const theme = useTheme();
    const { t } = useTranslation();

    if (selectedCompany === null) return;

    return (
        <Box sx={{ marginBlock: theme.spacing(2) }}>
            <Typography variant="body-bold">{t("unique_identifier", "Unique identifier")}</Typography>
            {": "}
            <Typography variant="body">
                {packaging.packaging?.externalId ?? packaging.packagingReference?.compositeId ?? "-"}
            </Typography>
        </Box>
    );
};
